import { generateKeys } from '../utils';
import { currencies } from './general';
export const entities = generateKeys({
    eu: {
        label: 'EU',
        value: 'eu',
    },
    mau: {
        label: 'MAU',
        value: 'mau',
    },
    sey: {
        label: 'SEY',
        value: 'sey',
    },
    km: {
        label: 'KM',
        value: 'km',
    },
    za: {
        label: 'ZA',
        value: 'za',
    },
});
export const companies = generateKeys({
    bdSwiss: {
        value: 'bdSwiss',
        label: 'Viverno EU',
        brand: 'bdSwiss',
        brandLabel: 'Viverno',
        domain: 'www.viverno.com',
        tradingName: 'Viverno',
        regulator: 'cysec',
        trademark: 'BDSwiss Holding Ltd',
        emailDomain: 'viverno.com',
        portalDomain: 'dashboard.viverno.com',
        migrationEmailLabel: 'Viverno EU',
        appropTestScoreThreshold: [40, 50],
        requiresAPTest: true,
        requiresEP: true,
        sortIndex: 1,
        kycDeadline: 15,
        registrationSteps: ['step1'],
        accountVerification: {
            profile: '',
            appropriatenessTest: 'FORCE_AFTER_LOGIN',
            economicProfile: 'FORCE_AFTER_LOGIN',
            kycStatus: '',
        },
        sendGridTemplate: 'viverno-generic',
        logo: 'https://branding.bdswiss.com/logos/bdSwiss.png',
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        strictVerificationRules: true,
        leverage: 30,
        groupRegistration: true,
        entity: entities.eu,
        newCompany: 'viverno',
        termsWebsiteLink: 'legal-documents',
    },
    bdSwissVanuatu: {
        value: 'bdSwissVanuatu',
        label: 'BDSwiss SEY',
        brand: 'bdSwiss',
        brandLabel: 'BDSwiss',
        domain: 'global.bdswiss.com',
        portalDomain: 'dashboard-global.bdswiss.com',
        tradingName: 'BDS Ltd',
        regulator: 'vfsc',
        trademark: 'BDS Ltd',
        emailDomain: 'bdswiss.com',
        appropTestScoreThreshold: [2, 29],
        requiresAPTest: true,
        requiresEP: true,
        sortIndex: 4,
        kycDeadline: 15,
        kycDeadlineExtension: 15,
        registrationSteps: ['step1'],
        accountVerification: {
            profile: '',
            appropriatenessTest: 'FORCE_AFTER_DEPOSIT',
            economicProfile: 'FORCE_AFTER_DEPOSIT',
            kycStatus: '',
        },
        sendGridTemplate: 'bdswiss-generic',
        logo: 'https://branding.bdswiss.com/logos/bdSwiss.png',
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        leverage: 400,
        groupRegistration: true,
        entity: entities.sey,
        termsWebsiteLink: 'general-terms-and-conditions',
    },
    bdSwissMauritius: {
        value: 'bdSwissMauritius',
        label: 'BDSwiss MAU',
        brand: 'bdSwiss',
        brandLabel: 'BDSwiss',
        domain: 'bdswiss.com',
        portalDomain: 'dashboard.bdswiss.com',
        tradingName: 'BDS Markets',
        regulator: 'fsc',
        trademark: 'BDS Markets',
        emailDomain: 'bdswiss.com',
        migrationEmailLabel: 'BDS Markets Mauritius',
        appropTestScoreThreshold: [2, 29],
        requiresAPTest: true,
        requiresEP: true,
        sortIndex: 3,
        kycDeadline: 15,
        kycDeadlineExtension: 15,
        registrationSteps: ['step1'],
        accountVerification: {
            profile: '',
            appropriatenessTest: 'FORCE_AFTER_DEPOSIT',
            economicProfile: 'FORCE_AFTER_DEPOSIT',
            kycStatus: '',
        },
        sendGridTemplate: 'bdswiss-generic',
        logo: 'https://branding.bdswiss.com/logos/bdSwiss.png',
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        leverage: 400,
        groupRegistration: true,
        entity: entities.mau,
        domainPrefix: 'mau',
        termsWebsiteLink: 'general-terms-and-conditions',
    },
    swissMarkets: {
        value: 'swissMarkets',
        label: 'Swiss Markets EU',
        brand: 'swissMarkets',
        brandLabel: 'Swiss Markets',
        domain: 'eu.swissmarkets.com',
        portalDomain: 'dashboard-eu.swissmarkets.com',
        tradingName: 'Swiss Markets',
        regulator: 'cysec',
        trademark: 'BDSwiss Holding Ltd',
        emailDomain: 'eu.swissmarkets.com',
        migrationEmailLabel: 'SwissMarkets EU',
        appropTestScoreThreshold: [40, 50],
        requiresAPTest: true,
        requiresEP: true,
        sortIndex: 2,
        kycDeadline: 15,
        registrationSteps: ['step1', 'step2', 'step3'],
        accountVerification: {
            profile: '',
            appropriatenessTest: 'FORCE_AFTER_LOGIN',
            economicProfile: 'FORCE_AFTER_LOGIN',
            kycStatus: '',
        },
        sendGridTemplate: 'swissmarkets-generic',
        logo: 'https://branding.bdswiss.com/logos/swissMarkets.png',
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        strictVerificationRules: true,
        leverage: 30,
        entity: entities.eu,
    },
    swissMarketsMauritius: {
        value: 'swissMarketsMauritius',
        label: 'Swiss Markets MAU',
        brand: 'swissMarkets',
        brandLabel: 'Swiss Markets',
        domain: 'swissmarkets.com',
        portalDomain: 'dashboard.swissmarkets.com',
        tradingName: 'BDS Markets',
        regulator: 'fsc',
        trademark: 'BDS Markets',
        emailDomain: 'swissmarkets.com',
        migrationEmailLabel: 'BDS Markets Mauritius',
        appropTestScoreThreshold: [2, 29],
        appropTestForexScore: 0,
        appropTestBinaryScore: 0,
        requiresAPTest: true,
        requiresEP: true,
        sortIndex: 5,
        kycDeadline: 15,
        kycDeadlineExtension: 15,
        registrationSteps: ['step1', 'step2', 'step3'],
        accountVerification: {
            profile: '',
            appropriatenessTest: 'FORCE_AFTER_DEPOSIT',
            economicProfile: 'FORCE_AFTER_DEPOSIT',
            kycStatus: '',
        },
        sendGridTemplate: 'swissmarkets-generic',
        logo: 'https://branding.bdswiss.com/logos/swissMarkets.png',
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        leverage: 400,
        entity: entities.mau,
    },
    swissMarketsVanuatu: {
        value: 'swissMarketsVanuatu',
        label: 'Swiss Markets SEY',
        brand: 'swissMarkets',
        brandLabel: 'Swiss Markets',
        domain: 'global.swissmarkets.com',
        portalDomain: 'dashboard-global.swissmarkets.com',
        tradingName: 'BDS Ltd',
        regulator: 'vfsc',
        trademark: 'BDS Ltd',
        emailDomain: 'swissmarkets.com',
        appropTestScoreThreshold: [2, 29],
        appropTestForexScore: 0,
        appropTestBinaryScore: 0,
        requiresAPTest: true,
        requiresEP: true,
        sortIndex: 6,
        kycDeadline: 15,
        kycDeadlineExtension: 15,
        registrationSteps: ['step1', 'step2', 'step3'],
        accountVerification: {
            profile: '',
            appropriatenessTest: 'FORCE_AFTER_DEPOSIT',
            economicProfile: 'FORCE_AFTER_DEPOSIT',
            kycStatus: '',
        },
        sendGridTemplate: 'swissmarkets-generic',
        logo: 'https://branding.bdswiss.com/logos/swissMarkets.png',
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        leverage: 400,
        entity: entities.sey,
    },
    bitrace: {
        value: 'bitrace',
        label: 'Bitrace Investments LTD',
        brand: 'bitrace',
        brandLabel: 'Bitrace',
        domain: 'bitrace-token.com',
        portalDomain: 'bitrace.bdswiss.com',
        emailDomain: 'bitrace-token.com',
        processPaymentAs: 'bdSwiss',
        requiresAPTest: false,
        requiresEP: false,
        sortIndex: 7,
        kycDeadline: 90,
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        leverage: 0,
        entity: entities.eu,
    },
    bdxAccounts: {
        value: 'bdxAccounts',
        label: 'BDS Markets Inc.',
        brand: 'bdxAccounts',
        brandLabel: 'BDS Markets',
        domain: 'bdxalliance.com',
        portalDomain: 'bdxcoin.bdxalliance.com',
        emailDomain: 'bdxalliance.com',
        processPaymentAs: 'bdSwissMauritius',
        requiresAPTest: false,
        requiresEP: false,
        sortIndex: 8,
        kycDeadline: 90,
        sendGridTemplate: 'bdx-generic',
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        leverage: 0,
        entity: entities.mau,
    },
    makeYourDay: {
        value: 'makeYourDay',
        label: 'MakeYourDay',
        brand: 'makeYourDay',
        brandLabel: 'Make Your Day',
        domain: 'makeyourday.io',
        portalDomain: 'makeyourday.bdxalliance.com',
        emailDomain: 'makeyourday.io',
        processPaymentAs: 'bdSwissMauritius',
        requiresAPTest: false,
        requiresEP: false,
        sortIndex: 9,
        kycDeadline: 90,
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        leverage: 0,
        entity: entities.mau,
    },
    cleanCoinAccounts: {
        value: 'cleanCoinAccounts',
        label: 'CleanCoin',
        brand: 'cleanCoinAccounts',
        brandLabel: 'CleanCoin',
        domain: 'praestentia.io',
        portalDomain: 'cleancoin.bdxalliance.com',
        emailDomain: 'praestentia.io',
        processPaymentAs: 'bdSwissMauritius',
        requiresAPTest: false,
        requiresEP: false,
        sortIndex: 10,
        kycDeadline: 90,
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        leverage: 0,
        entity: entities.mau,
    },
    bdSwissSouthAfrica: {
        value: 'bdSwissSouthAfrica',
        label: 'BDSwiss ZA',
        brand: 'bdSwiss',
        brandLabel: 'BDSwiss',
        domain: 'za.bdswiss.com',
        portalDomain: 'dashboard-za.bdswiss.com',
        tradingName: 'BDSwiss Markets SA (Pty) Ltd',
        regulator: 'fsca',
        trademark: 'BDSwiss Markets SA (Pty) Ltd',
        emailDomain: 'bdswiss.com',
        appropTestScoreThreshold: [2, 29],
        requiresAPTest: true,
        requiresEP: true,
        sortIndex: 4,
        kycDeadline: 15,
        kycDeadlineExtension: 15,
        registrationSteps: ['step1'],
        accountVerification: {
            profile: '',
            appropriatenessTest: 'FORCE_AFTER_DEPOSIT',
            economicProfile: 'FORCE_AFTER_DEPOSIT',
            kycStatus: '',
        },
        sendGridTemplate: 'bdswiss-generic',
        logo: 'https://branding.bdswiss.com/logos/bdSwiss.png',
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        leverage: 400,
        groupRegistration: true,
        entity: entities.za,
        termsWebsiteLink: 'legal-documents',
    },
    bdSwissComoros: {
        value: 'bdSwissComoros',
        label: 'BDSwiss KM',
        brand: 'bdSwiss',
        brandLabel: 'BDSwiss',
        domain: 'km.bdswiss.com',
        portalDomain: 'dashboard-km.bdswiss.com',
        tradingName: 'BDS Investments LTD',
        regulator: 'cfc',
        trademark: 'BDS Investments LTD',
        emailDomain: 'bdswiss.com',
        appropTestScoreThreshold: [2, 29],
        requiresAPTest: true,
        requiresEP: true,
        sortIndex: 4,
        kycDeadline: 15,
        kycDeadlineExtension: 15,
        registrationSteps: ['step1'],
        accountVerification: {
            profile: '',
            appropriatenessTest: 'FORCE_AFTER_DEPOSIT',
            economicProfile: 'FORCE_AFTER_DEPOSIT',
            kycStatus: '',
        },
        sendGridTemplate: 'bdswiss-generic',
        logo: 'https://branding.bdswiss.com/logos/bdSwiss.png',
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        leverage: 400,
        groupRegistration: true,
        entity: entities.km,
        termsWebsiteLink: 'legal-documents',
    },
});
